export enum IndividualActivationStepEnum {
  InEnrollment,
  InVerification,
  InPendingVerification,
  Activated,
}
